import { Component, OnInit } from '@angular/core';
import { PrinterClassService } from '../domain/printerClass/printer-class.service';
import { PrinterService } from '../domain/printer/printer.service';
import { Printer } from '../domain/printer/printer';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-printer',
  templateUrl: './printer.component.html',
  standalone: true,
  imports: [MatListModule, MatIconModule],
  styleUrls: ['./printer.component.css']
})
export class PrinterComponent implements OnInit {

  printers: Printer[] = [];

  constructor(private printerService: PrinterService) { }

  ngOnInit() {
    this.printerService.getPrinters().subscribe(
      (p) => this.printers = p,
      (err) => console.error(err)
    );
  }

}
